import React from 'react';
import { Button } from './ui/button';
import { Sparkles, Zap } from 'lucide-react';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-b from-black via-purple-950/20 to-black">
      {/* Animated Background */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple-600/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-pink-600/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center pt-20">
        {/* Logo */}
        <div className="flex justify-center mb-8 animate-fade-in">
          <div className="w-24 h-24 bg-gradient-to-br from-purple-500 via-pink-500 to-purple-600 rounded-2xl flex items-center justify-center shadow-2xl shadow-purple-500/50">
            <span className="text-white font-bold text-4xl">GO</span>
          </div>
        </div>

        {/* New models badge */}
        <div className="flex justify-center mb-6 animate-fade-in">
          <button
            data-testid="hero-new-models-badge"
            onClick={() => document.getElementById('whats-new')?.scrollIntoView({ behavior: 'smooth' })}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-purple-500/40 bg-purple-500/10 text-purple-300 text-sm hover:bg-purple-500/20 transition-colors duration-300"
          >
            <Sparkles size={14} />
            NEW: GPT-6 Astra, Claude Fable 5.1 &amp; 55 AI models now live
          </button>
        </div>

        {/* Main Heading */}
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight animate-fade-in-up">
          The World's First Game
          <br />
          <span className="bg-gradient-to-r from-purple-400 via-pink-400 to-purple-400 bg-clip-text text-transparent">
            Vibe Coding Agent
          </span>
        </h1>

        {/* Subheading */}
        <p className="text-base md:text-lg text-gray-300 mb-12 max-w-3xl mx-auto animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
          Chat your way to cinematic 2D &amp; 3D games — then share, remix and earn revenue from day one
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
          <Button
            size="lg"
            onClick={() => window.location.href = '/create'}
            className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white text-lg px-8 py-6 rounded-full shadow-lg shadow-purple-500/30 hover:shadow-purple-500/50 transition-all duration-300 transform hover:scale-105"
          >
            <Sparkles className="mr-2" size={20} />
            Try it Free
          </Button>
          <Button
            size="lg"
            variant="outline"
            onClick={() => document.getElementById('games').scrollIntoView({ behavior: 'smooth' })}
            className="border-2 border-purple-500 text-purple-400 hover:bg-purple-500/10 text-lg px-8 py-6 rounded-full transition-all duration-300"
          >
            <Zap className="mr-2" size={20} />
            See How It Works
          </Button>
        </div>

        {/* Features */}
        <div className="grid grid-cols-3 gap-8 mt-16 max-w-2xl mx-auto animate-fade-in-up" style={{ animationDelay: '0.6s' }}>
          <div className="text-center" data-testid="hero-stat-models">
            <div className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent mb-2">55 Models</div>
            <div className="text-gray-400 text-sm">GPT-6 Astra to Gemini 3.8</div>
          </div>
          <div className="text-center" data-testid="hero-stat-3d">
            <div className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent mb-2">2D &amp; 3D</div>
            <div className="text-gray-400 text-sm">Cinematic, Multi-Level</div>
          </div>
          <div className="text-center" data-testid="hero-stat-code">
            <div className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent mb-2">Zero Code</div>
            <div className="text-gray-400 text-sm">Just Prompts &amp; Remixes</div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-purple-400 rounded-full flex justify-center p-2">
          <div className="w-1 h-3 bg-purple-400 rounded-full animate-scroll"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;